// Traducerea erorilor din API pentru ecranele R.E.S.D.P.S. (spec E, 5.8). Serviciul respinge promisiunea cu
// eroarea axios; paginile afiseaza message si marcheaza campurile din fields.

export const RESDPS_MESSAGES = Object.freeze({
  "RESDPS-MISSING-FIELDS":
    "Completati campurile obligatorii pentru inregistrare.",
  "RESDPS-INVALID-FIELD": "Un camp are o valoare invalida.",
  "RESDPS-INVALID-CNP": "CNP-ul nu este valid.",
  "RESDPS-NOT-FOUND": "Dosarul nu exista.",
  "RESDPS-DUPLICATE-CNP": "Exista deja un dosar inregistrat pentru acest CNP.",
  "RESDPS-INVALID-STATE":
    "Operatia nu este permisa in starea actuala a dosarului.",
  "RESDPS-STALE":
    "Dosarul a fost modificat intre timp. Reincarcati si reincercati.",
  "RESDPS-CLASSIFY-TOO-EARLY": "Clasarea nu este inca posibila.",
  "RESDPS-BUSY": "Registrul este ocupat. Reincercati.",
  "RESDPS-TEMPLATE-MISSING":
    "Sablonul S.D.P.S. nu este publicat. Anuntati administratorul.",
  // Mesajul API-ului spune si ce marcaje lipsesc; acesta e doar rezerva, daca raspunsul vine fara mesaj.
  "RESDPS-TEMPLATE-MISMATCH":
    "Sablonul S.D.P.S. publicat nu mai are marcajele asteptate. Anuntati administratorul.",
});

// Descarcarea formularului C.D.P.S. necompletat cere intai versiunea in vigoare a sablonului
// (GET DocumentTemplates/CDPS/effective); cand nu exista una, API-ul raspunde cu NotFound() simplu,
// fara corp si fara errorCode, deci describeError nu poate deosebi acest caz de orice alt 404.
// Pagina verifica separat response.status === 404 si foloseste acest mesaj, in loc de describeError.
export const CDPS_TEMPLATE_MISSING_MESSAGE =
  "Sablonul C.D.P.S. nu este publicat. Anuntati administratorul.";

export const GENERAL_MESSAGES = Object.freeze({
  invalidData: "Datele trimise nu sunt valide.",
  unauthorized: "Sesiunea a expirat. Autentificati-va din nou.",
  forbidden: "Nu aveti permisiunea pentru R.E.S.D.P.S.",
  tooManyRequests: "Prea multe cereri. Asteptati un minut si reincercati.",
  server: "A aparut o eroare pe server.",
  network: "Serverul nu raspunde. Verificati conexiunea.",
  unknown: "A aparut o eroare. Incercati din nou.",
});

const RELOADABLE_CODES = ["RESDPS-STALE", "RESDPS-INVALID-STATE"];

// Cheile din ValidationProblemDetails ("DeceasedLastName", "$.dateOfDeath") devin numele din formular.
const toFieldName = (key) => {
  const name = String(key).replace(/^\$\./, "");
  return name.charAt(0).toLowerCase() + name.slice(1);
};

const described = (status, code, message, fields, data) => ({
  status,
  code,
  message,
  fields,
  data,
});

export function describeError(error) {
  const response = error && error.response;
  if (!response) {
    return described(null, null, GENERAL_MESSAGES.network, [], {});
  }

  const status = response.status;
  const data =
    response.data && typeof response.data === "object" ? response.data : {};
  const code = data.errorCode || null;

  if (code) {
    let fields = [];
    if (Array.isArray(data.fields)) fields = data.fields;
    else if (data.field) fields = [data.field];
    else if (code === "RESDPS-INVALID-CNP") fields = ["cnp"];
    return described(
      status,
      code,
      data.message || RESDPS_MESSAGES[code] || GENERAL_MESSAGES.unknown,
      fields,
      data
    );
  }

  if (status === 400) {
    const fields = data.errors ? Object.keys(data.errors).map(toFieldName) : [];
    return described(status, null, GENERAL_MESSAGES.invalidData, fields, data);
  }
  if (status === 401)
    return described(status, null, GENERAL_MESSAGES.unauthorized, [], data);
  if (status === 403)
    return described(status, null, GENERAL_MESSAGES.forbidden, [], data);
  if (status === 429)
    return described(status, null, GENERAL_MESSAGES.tooManyRequests, [], data);
  if (status >= 500) {
    const message = data.correlationId
      ? GENERAL_MESSAGES.server + " Cod: " + data.correlationId
      : GENERAL_MESSAGES.server;
    return described(status, null, message, [], data);
  }
  return described(
    status,
    null,
    data.message || GENERAL_MESSAGES.unknown,
    [],
    data
  );
}

// Dosarul s-a schimbat pe server: pagina ofera „Reincarca dosarul”.
export const isReloadable = (result) =>
  RELOADABLE_CODES.indexOf(result.code) !== -1;

export const isDuplicateCnp = (result) =>
  result.code === "RESDPS-DUPLICATE-CNP";
